// Wirney (2026-07-16) : selecteur de variante facon Louis Vuitton
// (variant_style = "dropdown_lv"). En-tete "Nom .... Valeur v" sur une ligne
// qui deplie un panneau listant les variantes (cochee = selectionnee,
// barree = indisponible).
//
// Ce script ne gere QUE l'ouverture/fermeture du panneau. Les <input radio>
// sous-jacents pilotent toujours la logique de variante native du theme
// (variant-picker.js ecoute leur "change" puis morphe le picker). La delegation
// est posee sur document pour survivre aux re-render/morphs du picker.
(function () {
  if (window.__wirneyLvVariantBound) return;
  window.__wirneyLvVariantBound = true;

  var OPEN = 'data-open';
  var OPT = '.variant-option--lv';

  function closeAll(except) {
    document.querySelectorAll(OPT + '[' + OPEN + '="true"]').forEach(function (el) {
      if (el === except) return;
      el.setAttribute(OPEN, 'false');
      var trigger = el.querySelector('.variant-option__lv-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    // Clic sur l'en-tete : bascule ouvert/ferme.
    var trigger = event.target.closest('.variant-option__lv-trigger');
    if (trigger) {
      var opt = trigger.closest(OPT);
      if (!opt) return;
      var willOpen = opt.getAttribute(OPEN) !== 'true';
      closeAll(opt);
      opt.setAttribute(OPEN, willOpen ? 'true' : 'false');
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    // Clic sur une variante : le radio se coche nativement -> le theme change la
    // variante et morphe le picker (qui revient ferme). On ferme aussi tout de
    // suite pour un retour immediat.
    var item = event.target.closest('.variant-option__lv-item');
    if (item) {
      var host = item.closest(OPT);
      if (host) host.setAttribute(OPEN, 'false');
      return;
    }

    // Clic en dehors : on ferme tout.
    if (!event.target.closest(OPT)) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
